import { Skeleton } from "@mui/material";
import { CoreButton } from "@verity/components/core";

export function IntegrationSettingsActions({
	actions,
	loading,
}: {
	actions: {
		text?: string;
		icon?: Parameters<typeof CoreButton>[0]["startIcon"];
		color?: Parameters<typeof CoreButton>[0]["color"];
		disabled?: boolean;
		onClick?: () => void;
		href?: string;
		buttonLoading?: boolean;
	}[];
	loading?: boolean;
}) {
	return (
		<div style={{ display: "flex", gap: "12px", width: "100%", justifyContent: "end", height: "33px" }}>
			{actions.map((action, index) =>
				loading ? (
					<Skeleton key={index} height="100%" width="150px" variant="rounded" />
				) : (
					<CoreButton
						key={`${index}-${action.text}`}
						color={action.color}
						startIcon={action.icon}
						style={{ padding: "2px 8px" }}
						onClick={action.onClick}
						component={action.href ? "a" : undefined}
						href={action.href}
						disabled={action.disabled}
						loading={action.buttonLoading}
						loadingPosition="end"
					>
						{action.text}
					</CoreButton>
				),
			)}
		</div>
	);
}
